// extracted by mini-css-extract-plugin
export default {"container":"SetList__container___KE7X6","setItem":"SetList__setItem___f5oK5"};